"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var IconBase_1 = tslib_1.__importDefault(require("./IconBase"));
var theme_1 = require("../theme"); // tslint:disable-line:no-deep-relative-imports
var getSize = function (_a) {
    var size = _a.size, theme = _a.theme;
    return ({
        width: theme.components.icon.size[size] || '100%',
        height: theme.components.icon.size[size] || '100%',
        display: 'inline-block'
    });
};
var getSVGStyle = function (_a) {
    var color = _a.color, theme = _a.theme;
    return theme_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      svg {\n        pointer-events: none;\n        fill: ", ";\n        width: inherit;\n        height: inherit;\n      }\n  "], ["\n      svg {\n        pointer-events: none;\n        fill: ", ";\n        width: inherit;\n        height: inherit;\n      }\n  "])), theme.palette[color]);
};
var Icon = theme_1.styled(IconBase_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", ";\n  ", ";\n  line-height: 0;\n  vertical-align: middle;\n"], ["\n  ", ";\n  ", ";\n  line-height: 0;\n  vertical-align: middle;\n"])), getSize, getSVGStyle);
/**
 * @component
 */
exports.default = (function (props) { return react_1.default.createElement(Icon, tslib_1.__assign({}, props)); });
var templateObject_1, templateObject_2;
